//FEDE export const API_URL = "http://local.dashbo.io:8000/";
export const API_URL = process.env.REACT_APP_API_URL;
// El Explorador de Datos pega a un servicio Cloud Run dedicado (data-service.dashbo.io) para que sus
// queries pesadas (20-30s) no saturen api-service y tumben el resto del backend (microcorte 2026-06-05,
// ver sentry-bugs/). En prod apunta a data-service.dashbo.io; en dev/local/staging cae a API_URL (mismo
// backend de siempre). Override opcional via REACT_APP_DATA_EXPLORER_API_URL.
export const DATA_EXPLORER_API_URL =
    process.env.REACT_APP_DATA_EXPLORER_API_URL
    || (API_URL && API_URL.includes('//api.dashbo.io') ? 'https://data-service.dashbo.io/' : API_URL);
// export const APP_URL = "https://app.dashbo.io/";
export const APP_URL = process.env.REACT_APP_APP_URL;
export const DSN = process.env.REACT_APP_DSN;
// REACT_APP_PUSHER_KEY quedó SIN USO: la cuenta de Pusher del tablero ya no se elige en el
// build. Hay un pool de cuentas y el backend le dice a cada agencia cuál le toca y qué canal
// escuchar (GET realtime/config/, ver websockets/WebSocketsClient.js). La env var puede
// seguir en el cloudbuild sin efecto; sacarla es opcional.
export const INTERCOM_SPACE_ID = process.env.REACT_APP_INTERCOM_SPACE_ID;
//PRODUCCIÓN
export const TIKTOK_APP_ID = process.env.REACT_APP_TIKTOK_APP_ID;
// LINKEDIN
export const LINKEDIN_AUTHORIZATION_URL = process.env.REACT_APP_LINKEDIN_AUTHORIZATION_URL;

// SHOPIFY
// https://shopify.dev/docs/apps/build/authentication-authorization/access-tokens/authorization-code-grant#redirect-using-a-3xx-redirect
export const SHOPIFY_NONCE = process.env.REACT_APP_SHOPIFY_NONCE;
export const SHOPIFY_CLIENT_ID = process.env.REACT_APP_SHOPIFY_CLIENT_ID;
export const SHOPIFY_REDIRECT_URL = process.env.REACT_APP_SHOPIFY_REDIRECT_URL;

// Pusher para agente (cuenta separada)
export const AGENT_PUSHER_KEY = process.env.REACT_APP_AGENT_PUSHER_KEY;
export const AGENT_PUSHER_CLUSTER = process.env.REACT_APP_AGENT_PUSHER_CLUSTER || 'sa1';

// Pusher para la burbuja de chat de soporte (Reemplazo de Intercom, Fase 3, cuenta separada).
// La key llega del BUILD (a diferencia de la del tablero, que reparte el Backend por
// `realtime/config/`): el cloudbuild la hornea desde el secret SUPPORT_PUSHER_KEY. Sin key, el
// diseño degrada a polling (ver SupportWebSocketsClient) — es el caso de un `npm start` local.
// El cluster default acompaña a la cuenta real ('mt1' desde el 2026-09-22): un cluster equivocado
// no da error, deja el chat en polling en silencio.
export const SUPPORT_PUSHER_KEY = process.env.REACT_APP_SUPPORT_PUSHER_KEY;
export const SUPPORT_PUSHER_CLUSTER = process.env.REACT_APP_SUPPORT_PUSHER_CLUSTER || 'mt1';

// Dashbo MCP API (para Dashbo AI playground)
export const MCP_API_URL = process.env.REACT_APP_MCP_API_URL || 'https://mcp.dashbo.io';